let gaTrackingId: string | undefined;

function getGtag() {
  function dummyFn(...args: any[]) {
    console.warn(`Tried to call analytics function before it was loaded was loaded`, args);
  }

  const gtag =
    typeof window === 'undefined' || !(window as any).gtag ? dummyFn : (window as any).gtag;

  return gtag;
}

type Heap = {
  track: (evName: string, props?: any) => void;
};

function getHeap() {
  return (window as any).heap as Heap | undefined;
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const googleAnalyticsPageView = (url: string) => {
  getGtag()('config', gaTrackingId, {
    page_path: url,
  });
};

type EventProps = {
  event_category?: string;
  event_label?: string;
  value?: number;
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export function googleAnalyticsEvent(eventName: string, props?: EventProps) {
  getGtag()('event', eventName, props);
}

export type ConsentType = 'necessary' | 'analytics' | 'targeting';

export function loadGoogleAnalytics(trackingId: string) {
  gaTrackingId = trackingId;
  return new Promise((resolve) => {
    // Load GA and execute all items from queue
    const scriptElem = document.createElement('script');
    scriptElem.addEventListener('load', () => {
      const w = window as any;
      w.dataLayer = w.dataLayer || [];
      function gtag(...a: any[]) {
        // eslint-disable-next-line prefer-rest-params
        w.dataLayer.push(arguments);
      }

      w.gtag = gtag;

      gtag('js', new Date());

      // For now, we just enable all Cookies for the app
      // as it is not publicly facing the open interwebs
      // gtag("consent", "default", {
      //   ad_storage: "denied",
      //   analytics_storage: "denied",
      // });

      gtag('config', gaTrackingId);

      resolve(gtag);
    });
    scriptElem.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;

    document.body.insertAdjacentElement('beforeend', scriptElem);
  });
}

function loadHeap(heapAppId: string) {
  if (process.env.NODE_ENV === 'development') {
    return;
  }

  const scriptElem = document.createElement('script');
  scriptElem.type = 'text/javascript';

  scriptElem.innerHTML = `
  window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
  heap.load("${heapAppId}");
`;
  document.body.insertAdjacentElement('beforeend', scriptElem);
}

export function giveCookieConsent(categories: ConsentType[]) {
  getGtag()('consent', 'update', {
    ad_storage: categories.includes('targeting') ? 'granted' : 'denied',
    analytics_storage: categories.includes('analytics') ? 'granted' : 'denied',
  });
}
